var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 29.619C23.5216 29.619 29.619 23.5215 29.619 15.9999C29.619 8.47831 23.5216 2.38086 16 2.38086C8.47838 2.38086 2.38092 8.47831 2.38092 15.9999C2.38092 23.5215 8.47838 29.619 16 29.619Z",
    stroke: "#9E9E9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8571 12.8567C12.8571 12.2351 13.0414 11.6275 13.3868 11.1106C13.7321 10.5938 14.223 10.191 14.7973 9.9531C15.3715 9.71523 16.0035 9.65299 16.6131 9.77426C17.2228 9.89553 17.7828 10.1949 18.2223 10.6344C18.6618 11.0739 18.9612 11.6339 19.0824 12.2436C19.2037 12.8532 19.1415 13.4852 18.9036 14.0594C18.6657 14.6337 18.2629 15.1246 17.7461 15.4699C17.2292 15.8153 16.6216 15.9996 16 15.9996V18.0948",
    stroke: "#9E9E9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4761 22.809C15.4761 23.0983 15.7107 23.3328 15.9999 23.3328C16.2892 23.3328 16.5238 23.0983 16.5238 22.809C16.5238 22.5197 16.2892 22.2852 15.9999 22.2852C15.7107 22.2852 15.4761 22.5197 15.4761 22.809Z",
    fill: "#9E9E9E",
    stroke: "#9E9E9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.00d6ec03d236f97e3df3be209dae8fc4.svg";
export { ForwardRef as ReactComponent };